import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/app/hooks";
import { logout } from "../../../redux/slices/authSlice";
import { Info } from "@mui/icons-material";
import "./PaymentStatus.scss";

const PaymentCancel: FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleBackToLogin = () => {
    dispatch(logout());
    navigate("/virtual-school/virtual-login", { state: { prefillUsername: true } });
  };

  return (
    <div className="paymentStatusCtn">
      <div className="paymentCard">
        <div className="cancelIconOuter">
          <div className="cancelIconInner">
            <Info />
          </div>
        </div>
        <h2 className="statusTitle">Payment Cancelled</h2>
        <p className="statusDescription">
          Your payment process has been cancelled. If this was a mistake, please try logging in again to complete your payment.
        </p>
        <div className="actionBtnRow">
          <button onClick={handleBackToLogin}>Try Again</button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
